"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setNotificationCountAction = exports.resetFlightState = exports.setPilot = exports.setPassenger = exports.resetPublishFlightOfferAction = exports.resetSearchStateAction = exports.resetPublishStateAction = exports.setFlightOffer = exports.setFlightDetails = exports.changeSearchDetails = exports.setMyOffers = exports.setMyFlights = exports.setFlights = exports.changePublishFlightOffer = exports.changePublishFlightData = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const DEFAULT_STATE = {
    publishFlight: {
        departureAirport: null,
        destinationAirport: null,
        request: false,
        date: null,
        price: undefined,
        description: "",
        dedicated: false,
        seats: null,
        aircraft: null,
        stopovers: [],
        duration: null
    },
    searchDetails: {
        departureAirport: null,
        destinationAirport: null,
        startDate: null,
        endDate: null,
        passengers: null
    },
    flightDetails: null,
    flights: [],
    myFlights: [],
    myOffers: [],
    publishFlightOffer: {
        departureAirport: null,
        destinationAirport: null,
        date: null,
        price: undefined,
        aircraft: null,
        stopovers: [],
        duration: null
    },
    passenger: null,
    pilot: null,
    flightOffer: null,
    notificationCount: 0,
};
const flightSlice = (0, toolkit_1.createSlice)({
    name: 'flight',
    initialState: DEFAULT_STATE,
    reducers: {
        changePublishFlightData: (state, action) => {
            return {
                ...state,
                publishFlight: {
                    ...state.publishFlight,
                    [action.payload.field]: action.payload.value
                }
            };
        },
        setFlights: (state, action) => {
            return {
                ...state,
                flights: action.payload
            };
        },
        setMyFlights: (state, action) => {
            return {
                ...state,
                myFlights: action.payload
            };
        },
        setMyOffers: (state, action) => {
            return {
                ...state,
                myOffers: action.payload
            };
        },
        changeSearchDetails: (state, action) => {
            return {
                ...state,
                searchDetails: {
                    ...state.searchDetails,
                    [action.payload.field]: action.payload.value
                }
            };
        },
        setFlightDetails: (state, action) => {
            return {
                ...state,
                flightDetails: action.payload
            };
        },
        setFlightOffer: (state, action) => {
            return {
                ...state,
                flightOffer: action.payload
            };
        },
        resetPublish: (state) => {
            return { ...state, publishFlight: DEFAULT_STATE.publishFlight };
        },
        resetSearch: (state) => {
            return { ...state, searchDetails: DEFAULT_STATE.searchDetails };
        },
        changePublishFlightOffer: (state, action) => {
            return {
                ...state,
                publishFlightOffer: {
                    ...state.publishFlightOffer,
                    [action.payload.field]: action.payload.value
                }
            };
        },
        resetPublishFlightOffer: (state) => {
            return { ...state, publishFlightOffer: DEFAULT_STATE.publishFlightOffer };
        },
        setPassenger: (state, action) => {
            return {
                ...state,
                passenger: action.payload
            };
        },
        setPilot: (state, action) => {
            return {
                ...state,
                pilot: action.payload
            };
        },
        resetFlightState: () => {
            return DEFAULT_STATE;
        },
        setNotificationCount: (state, action) => {
            return {
                ...state,
                notificationCount: action.payload.count,
            };
        }
    }
});
exports.default = flightSlice.reducer;
exports.changePublishFlightData = flightSlice.actions.changePublishFlightData;
exports.changePublishFlightOffer = flightSlice.actions.changePublishFlightOffer;
exports.setFlights = flightSlice.actions.setFlights;
exports.setMyFlights = flightSlice.actions.setMyFlights;
exports.setMyOffers = flightSlice.actions.setMyOffers;
exports.changeSearchDetails = flightSlice.actions.changeSearchDetails;
exports.setFlightDetails = flightSlice.actions.setFlightDetails;
exports.setFlightOffer = flightSlice.actions.setFlightOffer;
exports.resetPublishStateAction = flightSlice.actions.resetPublish;
exports.resetSearchStateAction = flightSlice.actions.resetSearch;
exports.resetPublishFlightOfferAction = flightSlice.actions.resetPublishFlightOffer;
exports.setPassenger = flightSlice.actions.setPassenger;
exports.setPilot = flightSlice.actions.setPilot;
exports.resetFlightState = flightSlice.actions.resetFlightState;
exports.setNotificationCountAction = flightSlice.actions.setNotificationCount;
